module.exports = __webpack_public_path__ + "static/img/nav8.69cd1676.svg";